var map = {
	"./3oaks-svg.svg": 831,
	"./abx-icon.svg": 8034,
	"./airtel.png": 6760,
	"./amatic-svg.svg": 3529,
	"./angledown.svg": 7258,
	"./aviator-svg.svg": 1828,
	"./aviator/aviator.png": 1202,
	"./aviatrix.svg": 547,
	"./aviatrix/aviatrix.jpeg": 1529,
	"./basketball.svg": 8280,
	"./c1.png": 5027,
	"./c10.png": 2827,
	"./c11.png": 7474,
	"./c12.png": 2617,
	"./c13.png": 7792,
	"./c14.png": 6447,
	"./c15.png": 8358,
	"./c16.png": 9037,
	"./c17.png": 2884,
	"./c18.png": 6755,
	"./c19.png": 5178,
	"./c2.png": 9416,
	"./c20.png": 4874,
	"./c21.png": 5635,
	"./c22.png": 1144,
	"./c23.png": 3857,
	"./c24.png": 7118,
	"./c25.png": 759,
	"./c26.png": 2028,
	"./c27.png": 9541,
	"./c28.png": 8674,
	"./c29.png": 2331,
	"./c3.png": 545,
	"./c30.png": 325,
	"./c4.png": 2062,
	"./c5.png": 1559,
	"./c6.png": 7628,
	"./c7.png": 9893,
	"./c8.png": 8514,
	"./c9.png": 9019,
	"./calender.svg": 1443,
	"./casinoAdv.png": 3823,
	"./close.svg": 5871,
	"./contact.svg": 243,
	"./crash.svg": 5326,
	"./customercare.svg": 9926,
	"./dark.svg": 4597,
	"./darkdropdownarrow.svg": 4729,
	"./darkhome.png": 3962,
	"./darkremove.svg": 8489,
	"./darksearch.svg": 4645,
	"./darts.svg": 5917,
	"./dashboardimg.png": 9954,
	"./dashboardimg2.png": 2794,
	"./dashboardimg3.png": 3555,
	"./downarrow.svg": 4032,
	"./dropdownarrow.svg": 673,
	"./drops.svg": 6477,
	"./elbet.svg": 7687,
	"./email.svg": 8343,
	"./esports.svg": 2960,
	"./evolution.svg": 2724,
	"./expanse/Titan Poker Multihand.png": 4619,
	"./expanse/battleforthethrone.jpg": 6330,
	"./expanse/beachpenalties.jpg": 4108,
	"./expanse/blackjack.jpg": 5058,
	"./expanse/bookofegypt.jpg": 6839,
	"./expanse/bountyhunters.jpg": 9240,
	"./expanse/candysbonanza.jpg": 6679,
	"./expanse/capitalcityderby.jpg": 3773,
	"./expanse/casinoheist.jpg": 4506,
	"./expanse/circusfeverdeluxe.jpg": 7778,
	"./expanse/clownfever.jpg": 7783,
	"./expanse/crazyhorses.jpg": 2083,
	"./expanse/dice.png": 3609,
	"./expanse/dicemini.jpg": 6700,
	"./expanse/dicemini.png": 1656,
	"./expanse/digits.png": 1622,
	"./expanse/dotsracing.jpg": 2250,
	"./expanse/evoji.jpg": 7405,
	"./expanse/expanse-logo.png": 7332,
	"./expanse/expanse.png": 4818,
	"./expanse/fairyinwonderland.jpg": 5346,
	"./expanse/forestrock.png": 6888,
	"./expanse/fortunefarm.jpg": 8221,
	"./expanse/gatesofolympia.jpg": 8574,
	"./expanse/godofcoins.png": 4229,
	"./expanse/hilo.png": 8342,
	"./expanse/hundredsupericy.jpg": 460,
	"./expanse/keno.png": 5741,
	"./expanse/leprechaunwish.jpg": 7742,
	"./expanse/luckysbettingshop.png": 1322,
	"./expanse/magicwheel.png": 4898,
	"./expanse/mayastreasure.png": 1830,
	"./expanse/mine.png": 8289,
	"./expanse/oddoneout.png": 5437,
	"./expanse/pia.jpg": 3420,
	"./expanse/piggyparty.png": 9380,
	"./expanse/pinataloca.png": 6588,
	"./expanse/piratespower.jpg": 8949,
	"./expanse/pixelpoker.png": 5231,
	"./expanse/planetspower.png": 2456,
	"./expanse/poker.png": 6597,
	"./expanse/richpanda.jpg": 8784,
	"./expanse/roulette.png": 7000,
	"./expanse/roulettedeluxe.png": 2029,
	"./expanse/shaolincrew.jpg": 4943,
	"./expanse/sicbo.png": 4000,
	"./expanse/spinningbuddha.png": 164,
	"./expanse/sticky777.png": 452,
	"./expanse/superheli.png": 399,
	"./expanse/swipe.png": 4056,
	"./expanse/thebookofeskimo.jpg": 2355,
	"./expanse/venividivici.png": 6197,
	"./expanse/wheel.jpg": 1615,
	"./expanse/wildcorrida.png": 3928,
	"./expanse/wildicyfruits.png": 7014,
	"./expanse/wildwestspirit.jpg": 5474,
	"./expanse/wildwhitewhale.png": 9882,
	"./expanse/zombieapocalypse.png": 9611,
	"./eye.svg": 4384,
	"./facebook.svg": 9321,
	"./fazi-svg.svg": 4852,
	"./fazi/BonusEpicCrown.png": 8727,
	"./fazi/BookOfSpells.png": 4165,
	"./fazi/BookOfSpells2.png": 8435,
	"./fazi/BookOfSpellsDeluxe.png": 7272,
	"./fazi/CloverBlast5.png": 20,
	"./fazi/CloverCoin.png": 700,
	"./fazi/EpicCrown10.png": 7853,
	"./fazi/EyeOfTut.png": 4631,
	"./fazi/HotStars.png": 1196,
	"./fazi/JewelsBeat.png": 884,
	"./fazi/JokerTripleDouble.png": 4504,
	"./fazi/KingOfThunder.png": 4694,
	"./fazi/MajesticCrown10.png": 728,
	"./fazi/MayansBattle.png": 9575,
	"./fazi/MysticJungle.png": 9876,
	"./fazi/ToxicHaze.png": 7769,
	"./fazi/TripleFieldsOfLuck.png": 363,
	"./fazi/Wild81.png": 4125,
	"./fire.svg": 6137,
	"./football.svg": 8118,
	"./futsal.svg": 3154,
	"./golden-monday.png": 2163,
	"./golden.svg": 3998,
	"./graydropdown.svg": 6435,
	"./grayremove.svg": 8316,
	"./greater.svg": 649,
	"./greentube-svg.svg": 8701,
	"./hacksaw-svg.svg": 656,
	"./handball.svg": 7877,
	"./home.png": 6574,
	"./ice-hockey.svg": 5904,
	"./igrasoft-svg.svg": 8735,
	"./imoon.svg": 509,
	"./insta.svg": 898,
	"./jb-roadblocks-sky.png": 2926,
	"./kaya.svg": 4331,
	"./leprecoins-icons.svg": 7370,
	"./light.svg": 1411,
	"./lite.svg": 7353,
	"./live.svg": 2767,
	"./location.svg": 1560,
	"./lock.svg": 6088,
	"./login.svg": 308,
	"./logo.png": 678,
	"./mail.svg": 632,
	"./mobileLogo.png": 4372,
	"./mobiledark.svg": 4963,
	"./mobilelight.svg": 8793,
	"./modalclose.svg": 4156,
	"./moonwhite.svg": 1361,
	"./netent-svg.svg": 7524,
	"./new.svg": 6845,
	"./payroll1.png": 7955,
	"./payroll2.png": 1096,
	"./playngo-svg.svg": 260,
	"./playson-svg.svg": 5200,
	"./pragmetic.svg": 7815,
	"./pushgaming-svg.svg": 7899,
	"./redtiger-svg.svg": 6846,
	"./referral.svg": 9406,
	"./remove.svg": 5169,
	"./safari.png": 5219,
	"./sagaming-icon.svg": 468,
	"./sagaming/sagaming.jpg": 8070,
	"./search.svg": 6621,
	"./selectdropdownsvg.svg": 7676,
	"./slider10img.png": 42,
	"./slider11img.png": 7641,
	"./slider12img.png": 8904,
	"./slider13img.png": 2551,
	"./slider14img.png": 4110,
	"./slider15img.png": 4733,
	"./slider16img.png": 3292,
	"./slider17img.png": 1915,
	"./slider18img.png": 7138,
	"./slider19img.png": 5473,
	"./slider2img.png": 295,
	"./slider3img.png": 1688,
	"./slider4img.png": 9821,
	"./slider5img.png": 2590,
	"./slider6img.png": 8251,
	"./slider7img.png": 7180,
	"./slider8img.png": 1345,
	"./slider9img.png": 7506,
	"./slots.svg": 3840,
	"./smallwhite.svg": 1641,
	"./smartsoft.svg": 2728,
	"./smartsoft/340x190_Roll_X.jpg": 2937,
	"./smartsoft/440x237_Double X.jpg": 7949,
	"./smartsoft/440x237_HUNT_X.jpg": 5760,
	"./smartsoft/440x237_Tug_Of_War.jpg": 2377,
	"./smartsoft/470x360 Mine Island.jpg": 2809,
	"./smartsoft/470x360_Rodeo.jpg": 5087,
	"./smartsoft/490x397 SmashX.png": 4681,
	"./smartsoft/500x500_CricketerX.jpg": 9666,
	"./smartsoft/Aviastar.png": 6906,
	"./smartsoft/Balloon.jpg": 2048,
	"./smartsoft/Cappadocia.jpg": 3514,
	"./smartsoft/CrazyHuntX.jpg": 6513,
	"./smartsoft/CricketX.jpg": 8821,
	"./smartsoft/FootballX.jpg": 3668,
	"./smartsoft/HelicopterX.jpg": 2224,
	"./smartsoft/JetX.png": 4834,
	"./smartsoft/PlinkoX.jpg": 7164,
	"./smartsoft/SpinX.jpg": 1025,
	"./smartsoft/TowerX.jpg": 5664,
	"./smartsoft/VirtualRoulette.jpg": 4552,
	"./spinmatic.svg": 8769,
	"./spinomenal-svg.svg": 3030,
	"./split.svg": 9175,
	"./spribe.svg": 1772,
	"./symbol1.png": 1246,
	"./symbol2.png": 3349,
	"./symbol3.png": 8079,
	"./symbol3png.png": 3567,
	"./symbol4.png": 627,
	"./symbol5.png": 9050,
	"./symbol6.png": 3713,
	"./table.svg": 6795,
	"./tada-svg.svg": 9388,
	"./tada/152.png": 5626,
	"./tada/153.png": 4483,
	"./tada/159.png": 4057,
	"./tada/160.png": 9933,
	"./tada/161.png": 8804,
	"./tada/163.png": 6166,
	"./tada/164.png": 1145,
	"./tada/166.png": 4443,
	"./tada/171.png": 2123,
	"./tada/172.png": 3792,
	"./tada/173.png": 8265,
	"./tada/174.png": 8182,
	"./tada/175.png": 5119,
	"./tada/176.png": 8260,
	"./tada/177.png": 2157,
	"./tada/178.png": 4378,
	"./tada/179.png": 2131,
	"./tada/180.png": 7319,
	"./tada/181.png": 7822,
	"./tada/182.png": 5653,
	"./tada/183.png": 3388,
	"./tada/191.png": 149,
	"./tada/193.png": 1111,
	"./tada/194.png": 5944,
	"./tada/195.png": 3809,
	"./tada/197.png": 1219,
	"./tada/198.png": 3556,
	"./tada/199.png": 3501,
	"./tada/200.png": 8012,
	"./tada/203.png": 5591,
	"./tada/204.png": 3448,
	"./tada/208.png": 3140,
	"./tada/209.png": 4269,
	"./tada/211.png": 670,
	"./tada/212.png": 6421,
	"./tada/214.png": 403,
	"./tada/216.png": 3761,
	"./tada/217.png": 3544,
	"./tada/219.png": 6454,
	"./tada/220.png": 5430,
	"./tada/221.png": 7167,
	"./tada/222.png": 3604,
	"./tada/223.png": 6109,
	"./tada/224.png": 4546,
	"./tada/225.png": 3547,
	"./tada/226.png": 8512,
	"./tada/228.png": 4446,
	"./tada/229.png": 2135,
	"./tada/230.png": 2081,
	"./tada/231.png": 4216,
	"./tada/232.png": 9491,
	"./tada/233.png": 1914,
	"./tada/235.png": 9324,
	"./tada/236.png": 9383,
	"./tada/237.png": 1070,
	"./tada/238.png": 9977,
	"./tada/239.png": 5152,
	"./tada/240.png": 9843,
	"./tada/241.png": 6425,
	"./tada/242.png": 8242,
	"./tada/244.png": 4980,
	"./tada/245.png": 602,
	"./tada/252.png": 5081,
	"./tada/253.png": 8832,
	"./tada/254.png": 1055,
	"./tada/258.png": 1859,
	"./tada/259.png": 6650,
	"./tada/261.png": 739,
	"./tada/262.png": 3880,
	"./tada/263.png": 4097,
	"./tada/264.png": 1006,
	"./tada/272.png": 7831,
	"./tada/273.png": 7838,
	"./tada/289.png": 6085,
	"./tada/297.png": 6976,
	"./tada/299.png": 7166,
	"./tada/300.png": 1693,
	"./tada/302.png": 2031,
	"./tada/305.png": 6656,
	"./tada/307.png": 6322,
	"./tada/324.png": 1127,
	"./tada/327.png": 444,
	"./tada/372.png": 4790,
	"./tada/374.png": 960,
	"./tada/375.png": 7865,
	"./tada/376.png": 9682,
	"./tada/377.png": 811,
	"./tada/378.png": 7212,
	"./tada/379.png": 277,
	"./tada/389.png": 9588,
	"./tada/392.png": 2238,
	"./tada/393.png": 1617,
	"./tada/394.png": 9150,
	"./tada/397.png": 949,
	"./tada/399.png": 1483,
	"./tada/403.png": 8113,
	"./tada/404.png": 7102,
	"./tada/407.png": 4453,
	"./tada/408.png": 5298,
	"./tada/419.png": 9172,
	"./tada/421.png": 2569,
	"./tada/422.png": 1602,
	"./tada/423.png": 6427,
	"./tada/424.png": 2564,
	"./tada/427.png": 9423,
	"./tada/439.png": 7642,
	"./tada/440.png": 2150,
	"./tada/441.png": 5951,
	"./tada/442.png": 676,
	"./tada/444.png": 3938,
	"./tada/447.png": 2121,
	"./tada/458.png": 2969,
	"./tada/459.png": 1792,
	"./tada/460.png": 5820,
	"./tada/463.png": 103,
	"./tada/464.png": 4936,
	"./tada/468.png": 3508,
	"./tada/469.png": 4637,
	"./tada/470.png": 5079,
	"./tada/474.png": 5187,
	"./tada/485.png": 303,
	"./tada/495.png": 4112,
	"./tada/504.png": 1471,
	"./tada/512.png": 7586,
	"./tada/513.png": 8715,
	"./tada/517.png": 1711,
	"./tada/518.png": 4232,
	"./tada/523.png": 7022,
	"./tada/524.png": 9489,
	"./tada/526.png": 6403,
	"./tada/529.png": 6180,
	"./tada/531.png": 8083,
	"./tada/534.png": 2094,
	"./tada/536.png": 3212,
	"./tada/540.png": 983,
	"./tada/541.png": 1758,
	"./tada/542.png": 5765,
	"./tada/543.png": 2876,
	"./tada/545.png": 8890,
	"./tada/546.png": 9473,
	"./tada/547.png": 1992,
	"./tada/549.png": 4278,
	"./tada/551.png": 9637,
	"./tada/554.png": 9080,
	"./tada/581.png": 4890,
	"./tada/589.png": 7810,
	"./tada/605.png": 613,
	"./tada/606.png": 6606,
	"./tictok.svg": 8907,
	"./top.svg": 8602,
	"./user.svg": 3084,
	"./userForm.svg": 8038,
	"./veligames-icon.svg": 9834,
	"./veligames/10.jpg": 6978,
	"./veligames/1001.png": 4935,
	"./veligames/11.png": 111,
	"./veligames/12.png": 6548,
	"./veligames/2.jpg": 2391,
	"./veligames/3.png": 4430,
	"./veligames/4.jpg": 9945,
	"./veligames/5.png": 600,
	"./veligames/7.png": 2746,
	"./veligames/8.png": 5629,
	"./veligames/9.png": 2388,
	"./vip-casino.png": 7488,
	"./virtuals.svg": 249,
	"./volleyball.svg": 301,
	"./wallet.svg": 2550,
	"./waterpolo.svg": 5457,
	"./whatsapp.svg": 267,
	"./whitecalender.svg": 8750,
	"./whitedown.svg": 1364,
	"./whiteselectdown.svg": 3100,
	"./whitesun.svg": 1922,
	"./x.svg": 6060,
	"./yt.svg": 7390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6133;